import { baseApiURL } from "../../Utilities/utility";
import axios from "axios";

export function factoryList (
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Quotation/FactoryList ",
        options
    )
        .then((response) => response.json())
        .then((resp) => {
            return resp.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function searchFactoryList (
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Quotation/FactoryList ",
        options
    )
        .then((response) => response.json())
        .then((resp) => {
            return resp.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function exportQuotationBasedOnFactoryList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        url: baseApiURL + "/Quotation/ExportQuotationBasedOnFactoryList",
        responseType: "arraybuffer",
       
        headers: {
             Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
       data:data

    };
    return axios(options)
        .then((response) => {
            return response;
            console.log(response);
        })
        .catch((error) => {
            return error;
        });

}

export function deleteQuotation(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    id
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: JSON.stringify(id),
       
    };
    
    return fetch(baseApiURL + "/Quotation/DeleteQuotation?id=" + id + "&QuotationID", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getQuotationRefNo(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/GetQuotationRefNo" , options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function GetOfficeList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    selectValue


) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId,
            
        },

    };
    return fetch(baseApiURL + "/Quotation/GetOfficeList?selectValue=" + selectValue, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetCompetitorList(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    selectValue

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/GetCompetitorList?selectValue=" + selectValue, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function Getdetailsofmlfb(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    id
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: JSON.stringify(id),
       
    };
    
    return fetch(baseApiURL + "/Quotation/GetDetailsOfMLFB", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function drawingUpload(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
    ) {
    const options = {
        method: "post",
        headers: {
           Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            RoleName: roleName,
            userId : userId
        },
       
        body: data,
    };
    return fetch(baseApiURL + "/Quotation/UploadDrawing", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getPreviewDrawing(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    quotationdetailsid

) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/Quotation/PreviewNonStandardDrawing?quotationdetailsid=" + quotationdetailsid, options)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

